var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #cecece;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #f7f7f7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0422",
    "data-name": "\\u0422"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "365.38 422 185.38 422 275.38 242 365.38 422"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "185.38 422 365.38 422 275.38 602 185.38 422"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.38 602 95.38 602 185.38 422 275.38 602"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "455.38 602 275.38 602 365.38 422 455.38 602"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "275.38 602 455.38 602 365.38 782 275.38 602"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.38 242 455.38 242 365.38 422 275.38 242"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "388.62 422 568.62 422 478.62 602 388.62 422"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "568.62 422 388.62 422 478.62 242 568.62 422"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "748.62 422 568.62 422 658.62 242 748.62 422"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "478.62 242 658.62 242 568.62 422 478.62 242"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "838.62 602 658.62 602 748.62 422 838.62 602"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "568.62 422 748.62 422 658.62 602 568.62 422"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "928.62 422 748.62 422 838.62 242 928.62 422"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "748.62 422 928.62 422 838.62 602 748.62 422"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d164d11a08aacdbb97a9832dfbf553ca.svg";
export { ForwardRef as ReactComponent };